module.exports = __webpack_public_path__ + "img/onlinestore.891b0be2.png";